import * as React from "react";

import {
  InitialStateMinimumRequirements_Analytics,
  InitialStateMinimumRequirements_Pack_JoinDrawerFull,
  InitialStateMinimumRequirements_PopularCategories,
  InitialStateMinimumRequirements_StaticMedia,
} from "../../../Common";

import { InitialStateMinimumRequirements_MyBag } from "../my-bag-provider";

interface ReactMyBagInitialStateConsumerInterface {
  initialState: ReactMyBagInitialState;
}

interface ReactMyBagInitialState
  extends InitialStateMinimumRequirements_Analytics,
    InitialStateMinimumRequirements_Pack_JoinDrawerFull,
    InitialStateMinimumRequirements_MyBag,
    InitialStateMinimumRequirements_StaticMedia,
    InitialStateMinimumRequirements_PopularCategories {
  isApplePayEnabled?: boolean;
  isGooglePayEnabled?: boolean;
  originCountryCode?: string;

  orderId?: any;
  orderEmail?: string;
}

const defaultValue = {} as unknown as ReactMyBagInitialStateConsumerInterface;

const ReactMyBagInitialStateContext = React.createContext(defaultValue);

export const ReactMyBagInitialStateProvider: React.FunctionComponent = (
  props
) => {
  const initialState: ReactMyBagInitialState = React.useMemo(() => {
    const mountElement = document.querySelector(
      "[data-bbnt-new-checkout-2022-mybag]"
    ) as HTMLElement;

    const initialStateJsonString =
      mountElement?.dataset?.["reactNewCheckout-2022Mybag__initialstate"] ||
      "{}";

    const initialState = JSON.parse(initialStateJsonString);

    return initialState;
  }, []);
  const value: ReactMyBagInitialStateConsumerInterface = React.useMemo(
    () => ({ initialState }),
    [initialState]
  );
  return (
    <ReactMyBagInitialStateContext.Provider value={value}>
      {props.children || []}
    </ReactMyBagInitialStateContext.Provider>
  );
};

export const useReactMyBagInitialState = () =>
  React.useContext(ReactMyBagInitialStateContext);
